import { useMutation } from '@apollo/client';
import { useEffect } from 'react';

import { DreamJobsSetConsentDetailsDocument } from '@xing-com/crate-dream-machine-graphql';

import { useSearchAndShuffleContext } from './context';

type UseConsentReturn = {
  addConsent: () => void;
};

export function useConsent(): UseConsentReturn {
  const {
    consentTaken,
    decks,
    setConsentTaken,
    tooltipOnCardId,
    setTooltipOnCardId,
  } = useSearchAndShuffleContext();
  const [saveConsent] = useMutation(DreamJobsSetConsentDetailsDocument);

  const findFirstTakenCard = (): string | undefined => {
    for (let i = 0; i < decks?.[0]?.cards?.length; i++) {
      for (let j = 0; j < decks.length; j++) {
        const card = decks[j].cards?.[i];
        if (card?.data?.type === 'TakenJob') {
          return card.data.id || undefined;
        }
      }
    }
    return undefined;
  };

  const addConsent = (): void => {
    saveConsent();
    setConsentTaken(true);
    setTooltipOnCardId(undefined);
  };

  useEffect(() => {
    if (tooltipOnCardId === undefined && !consentTaken) {
      const firstTakenCard = findFirstTakenCard();
      if (firstTakenCard) {
        setTooltipOnCardId(firstTakenCard);
      }
    }
  }, [consentTaken, decks]);

  return {
    addConsent,
  };
}
